var _window = window;
var Log = /** @class */ (function () {
    function Log() {
    }
    Log.debug = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).debug.apply(_a, data) : console.debug.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'debug', data);
        }
    };
    Log.log = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).info.apply(_a, data) : console.log.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'log', data);
        }
    };
    Log.info = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).info.apply(_a, data) : console.info.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'info', data);
        }
    };
    Log.warn = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).warn.apply(_a, data) : console.warn.apply(console, data);
        }
        catch (e) {
            Log.error('日志发生错误', 'warn', data);
        }
    };
    Log.error = function () {
        var _a;
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        try {
            _window.log ? (_a = _window.log).error.apply(_a, data) : console.error.apply(console, data);
        }
        catch (e) {
            console.error('日志发生错误', 'error', data);
        }
    };
    Log.time = function (label) {
        var options = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            options[_i - 1] = arguments[_i];
        }
        var value = {
            time: Date.now(),
            options: options,
        };
        this.sTimeLableMap.set(label, value);
    };
    Log.timeEnd = function (label) {
        var endTime = Date.now(); //  放到前面  减少map查询对结束时间的影响
        var value = Log.sTimeLableMap.get(label);
        if (value !== undefined) {
            var startTime = value.time;
            var optionsStr = value.options && value.options.map(function (item) { return JSON.stringify(item); }).join('-') || '';
            Log.debug("label: " + label + ": " + (endTime - startTime) + "ms. " + optionsStr); // 打印毫秒差
            this.sTimeLableMap.delete(label); // 用完了就删掉
        }
        else {
            // Log.error(`no label named ${label} exsit while call timeEnd.`);  // 打印毫秒差
        }
    };
    Log.sTimeLableMap = new Map();
    return Log;
}());
export default Log;
export { Log };
//# sourceMappingURL=Log.js.map